import { useMutation, useQueryClient } from '@tanstack/react-query';
import { loaders } from './custom-categories.loaders';
import { customCategoriesKeys } from './custom-categories.queries';

export const useCreateCustomCategory = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createCustomCategory, {
    onSuccess: () => {
      return queryClient.invalidateQueries(customCategoriesKeys.lists);
    },
  });
};

export const useEditCustomCategory = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.editCustomCategory, {
    onSuccess: () => {
      return queryClient.invalidateQueries(customCategoriesKeys.all);
    },
  });
};

export const useDeleteCustomCategory = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteCustomCategory, {
    onSuccess: () => {
      return queryClient.invalidateQueries(customCategoriesKeys.lists);
    },
  });
};

export const useCreateCustomCategoryValue = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.createCustomCategoryValue, {
    onSuccess: () => {
      return queryClient.invalidateQueries(customCategoriesKeys.all);
    },
  });
};

export const useEditCustomCategoryValue = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.editCustomCategoryValue, {
    onSuccess: () => {
      return queryClient.invalidateQueries(customCategoriesKeys.all);
    },
  });
};

export const useDeleteCustomCategoryValue = () => {
  const queryClient = useQueryClient();

  return useMutation(loaders.deleteCustomCategoryValue, {
    onSuccess: () => {
      return queryClient.invalidateQueries(customCategoriesKeys.lists);
    },
  });
};
